
export interface MainPackageContract{
  code: string;
  name: string;
  nodes: MainPackageContractNode[]
}
export type MainPackageContractNode = API.PROJECT.SalesContractNode & { percent: number }
  
export interface SubPackageContract {
  code: string;
  name: string;
  hasCanPayment?: boolean;
  nodes: SubPackageContractNode[]
}
export type SubPackageContractNode = API.PROJECT.ContractExpense & { percent: number }

export const MilestoneStatus = {
  PENDING : 'PENDING',
  PARTIAL : 'PARTIAL',
  COMPLETED : 'COMPLETED',
  OVERDUE : 'OVERDUE'
} as const